// extracted by mini-css-extract-plugin
module.exports = {"button":"SwipeController_button__o2VGQ","text":"SwipeController_text__5sFok","index":"SwipeController_index__uc_8L"};